export const FILTERED_STUDENTS = 'FILTERED_STUDENTS';
export const ERROR_DETECTED = 'ERROR_DETECTED';
export const UPDATE_SORTED_STUDENTS_LIST = 'UPDATE_SORTED_STUDENTS_LIST';
export const UPDATE_SORTED_ASSIGNED_LIST = 'UPDATE_SORTED_ASSIGNED_LIST';
export const SHOW_TOAST = 'SHOW_TOAST';
export const CLASSROOMS_ACQUIRED = 'CLASSROOMS_ACQUIRED';
export const UPDATE_SORT_PROPERTIES = 'UPDATE_SORT_PROPERTIES';
export const APPLY_FILTER = 'APPLY_FILTER';
export const SHOW_HIDE_SEARCH_PANEL = 'SHOW_HIDE_SEARCH_PANEL';
export const DISPLAY_MODAL_INFORMATION = 'DISPLAY_MODAL_INFORMATION';
export const HIDE_STANDARD = 'HIDE_STANDARD';
export const UPDATE_STUDENT_ASSIGNMENT = 'UPDATE_STUDENT_ASSIGNMENT';
export const GRID_CELL_SELECTION = 'GRID_CELL_SELECTION';
export const SET_ACTIVE_CLASS = 'SET_ACTIVE_CLASS';
export const SET_ACTIVE_GROUP = 'SET_ACTIVE_GROUP';
export const RESTRICT_ACCESS_FAILURE = 'RESTRICT_ACCESS_FAILURE';
export const RESTRICT_ACCESS_REQUEST = 'RESTRICT_ACCESS_REQUEST';
export const RESTRICT_ACCESS_SUCCESS = 'RESTRICT_ACCESS_SUCCESS';
export const TOPICS_ACQUIRED_REQUEST = 'TOPICS_ACQUIRED_REQUEST';
export const TOPICS_ACQUIRED_SUCCESS = 'TOPICS_ACQUIRED_SUCCESS';
export const TOPICS_ACQUIRED_FAILURE = 'TOPICS_ACQUIRED_FAILURE';
export const COURSE_TOPICS_ACQUIRED_REQUEST = 'COURSE_TOPICS_ACQUIRED_REQUEST';
export const COURSE_TOPICS_ACQUIRED_SUCCESS = 'COURSE_TOPICS_ACQUIRED_SUCCESS';
export const COURSE_TOPICS_ACQUIRED_FAILURE = 'COURSE_TOPICS_ACQUIRED_FAILURE';
export const UPDATE_COURSE_ID = 'UPDATE_COURSE_ID';
export const UPDATE_TOPICS = 'UPDATE_TOPICS';
export const UPDATE_SELECTED_TOPICS = 'UPDATE_SELECTED_TOPICS';
export const UPDATE_SELECTED_ACTIVITIES = 'UPDATE_SELECTED_ACTIVITIES';
export const TOGGLE_TOPICS_EXPAND_COLLAPSE = 'TOGGLE_TOPICS_EXPAND_COLLAPSE';
export const SET_TOPIC_TO_DIRTY = 'SET_TOPIC_TO_DIRTY';
export const UPDATE_DATE_PREFERENCE = 'UPDATE_DATE_PREFERENCE';
export const QUICK_SELECTION = 'QUICK_SELECTION';
export const SELECT_EQUAL_LESS_THAN_CELLS = 'SELECT_EQUAL_LESS_THAN_CELLS';
export const STUDENT_SINGLE_ACTIVITY_REPORT_REQUEST =
  'STUDENT_SINGLE_ACTIVITY_REPORT_REQUEST';
export const STUDENT_SINGLE_ACTIVITY_REPORT_SUCCESS =
  'STUDENT_SINGLE_ACTIVITY_REPORT_SUCCESS';
export const UPDATE_ASSIGNMENT_FILTERS = 'UPDATE_ASSIGNMENT_FILTERS';
export const CLEAR_ASSIGNMENT_FILTERS = 'CLEAR_ASSIGNMENT_FILTERS';
export const STUDENT_RESULT_REQUEST = 'STUDENT_RESULT_REQUEST';
export const STUDENT_RESULT_SUCCESS = 'STUDENT_RESULT_SUCCESS';
export const UPDATE_STUDENT_ASSIGNMENTS_SELECTED =
  'UPDATE_STUDENT_ASSIGNMENTS_SELECTED';



// WEBPACK FOOTER //
// ./containers/course-assign/course-assign-types.js